import React, { useContext } from 'react';
import { Card, CardContent, Typography, CardActions, Tooltip, Slider, withStyles, Box, } from '@material-ui/core';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ClearIcon from '@material-ui/icons/Clear';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import AppContext from "../../components/appContext";
import { useStyleActivity } from "./Activity.css";
import ButtonStyled from '../../components/general/ButtonStyled';


const PrettoSlider = withStyles({
    track: {
        height: 8,
        borderRadius: 4,
        color: "#37A8AF",
    },
    rail: {
        height: 8,
        borderRadius: 4,
        color: "#F29B12",
        opacity: "0.9",
    },
    thumb: {
        display: "none",
    },
})(Slider);


const ActivityCard = ({
    act,
    handleChange,
    PlusInfos,
    Inscrit,
    ChoisirAct,
}) => {

    const classesAccueil = useStyleActivity();
    const myContext = useContext(AppContext);

    const handleMouseMove = (event) => {
        const element = event.currentTarget;
        const rect = element.getBoundingClientRect(); // Position de l'élément relative à la fenêtre

        // Calculer la position de la souris par rapport à l'élément sans tenir compte du défilement
        const mouseX = event.clientX - rect.left;
        const mouseY = event.clientY - rect.top;

        // Appliquer les variables CSS
        element.style.setProperty("--mouse-x", `${mouseX}px`);
        element.style.setProperty("--mouse-y", `${mouseY}px`);
    };


    const getRigthFormat = (nb) => {
        return nb && nb > 0 ? nb : 0;
    };


    return (
        <Card
            className={[classesAccueil.root, classesAccueil[act?.ID_parent === 0 ? 'root' : 'rootSousActivite'], classesAccueil[act?.ID_parent === 0 ? 'rootHover' : 'rootSousActiviteHover']].join(" ")}
            id={act.id}
            variant="outlined"
            color="primary"
            onMouseMove={handleMouseMove}
            style={{ display: 'flex', flexDirection: 'column' }}
        >
            <Box
                className={classesAccueil.presentationText}
                id={act.id}
                onClick={() => { act.ID_parent === 0 && handleChange(act.id); }}
                style={{ display: 'flex', flexDirection: 'column', flexGrow: 1, position: 'relative' }}
            >
                <CardContent
                    id={act.id}
                    style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}
                >
                    <Typography
                        gutterBottom
                        id={act.id}
                        variant="h6"
                        className={classesAccueil.titreCard}
                        title={act.description}
                    >
                        {act.interne && (
                            <Tooltip
                                title={<h3>Activité interne</h3>}
                                aria-label="Activité interne"
                                placement="bottom"
                            >
                                <VisibilityOffIcon />
                            </Tooltip>
                        )}
                        {!act.active && (
                            <Tooltip
                                title={<h3>Inactive</h3>}
                                aria-label="Inactive"
                                placement="bottom"
                            >
                                <ClearIcon />
                            </Tooltip>
                        )}
                        {act.nom}
                    </Typography>
                    <Typography
                        gutterBottom
                        id={act.id}
                        variant="body1"
                        component="h5"
                        className={classesAccueil.titreCard}
                    >
                        {act.description}
                    </Typography>

                    {/* Actions centrées verticalement */}
                    <div style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                        {act.ID_parent > 0 && (
                            <CardActions style={{ justifyContent: 'flex-end', width: '100%' }}>
                                {act.plusinfo && (
                                    <ButtonStyled
                                        onClick={(_) => {
                                            PlusInfos(act.id, act.description, act.nom, act.descriptionLongue);
                                        }}
                                        startIcon={<InfoOutlinedIcon />}
                                        size="small"
                                        color='grisBtnLigth'
                                    >
                                        plus d'infos
                                    </ButtonStyled>
                                )}
                                {(myContext.User_Administrator ||
                                    (myContext.User_Chef &&
                                        myContext.user?.actionsIds?.includes(String(act.id)))) && (
                                        <ButtonStyled
                                            onClick={(_) => Inscrit(act.id, act.description, act.nom)}
                                            size="small"
                                        color='grisBtnLigth'
                                        >
                                            Les inscrits
                                        </ButtonStyled>
                                    )}
                                {act.choisissable && (
                                    <ButtonStyled
                                        onClick={(_) =>
                                            ChoisirAct(act.id, act.description, act.nom)
                                        }
                                        size="small"
                                        color='grisBtnLigth'
                                    >
                                        Choisir
                                    </ButtonStyled>
                                )}
                            </CardActions>
                        )}
                    </div>
                </CardContent>

                {/* Mettre le PrettoSlider en dehors du CardContent */}
                <div style={{ padding: '16px', marginTop: '20px', width: '100%' }}>
                    {/* Icon avec animation */}
                    <p className={classesAccueil.iconCustom}>
                        <i
                            id={act.id}
                            className={act.icone !== '' ? 'fa ' + act.icone : 'fas fa-user'}
                            aria-hidden="true"
                        ></i>
                    </p>
                    <Typography
                        id={act.id}
                        style={{
                            marginBlockStart: '3%',
                            textAlign: 'right',
                        }}
                    >
                        Occupation {act.nbinscrit}/{act.nbideal}
                    </Typography>
                    <PrettoSlider
                        key={`${act.id}-${act.nbideal}-${act.nbinscrit}`}// pour forcer a recrer un slider pour que le calcul de 0/0 soit toujours identique 
                        id={act.id}
                        max={getRigthFormat(act.nbideal)}
                        value={getRigthFormat(act.nbinscrit)}
                    />
                </div>
            </Box>
        </Card>
    );
};

export default ActivityCard;
